"use client"

import { ChevronRight, Home } from "lucide-react"

const BannerSectionFirst = () => {
    const fontStyle = { fontFamily: '"Plus Jakarta Sans", sans-serif' };

    return (
        <section className="relative w-full bg-white" style={{ fontFamily: '"Plus Jakarta Sans", sans-serif' }}>
            {/* Khai báo animation dùng trong component */}
            <style dangerouslySetInnerHTML={{
                __html: `
                @keyframes bounce-horizontal {
                    0%, 100% { transform: translateX(0); animation-timing-function: cubic-bezier(0.8, 0, 1, 1); }
                    50% { transform: translateX(-25%); animation-timing-function: cubic-bezier(0, 0, 0.2, 1); }
                }
            `}} />

            {/* Container bao toàn bộ banner */}
            <div className="relative w-full px-4 md:px-6 xl:px-8 2xl:px-12 min-[1920px]:px-16 pb-24 md:pb-0">

                {/* Khung banner chính */}
                <div className="relative w-full h-[550px] md:h-[360px] xl:h-[420px] 2xl:h-[550px] min-[1920px]:h-[750px] rounded-2xl overflow-visible md:overflow-hidden group">

                    {/* Ảnh nền cho mobile */}
                    <img
                        src="/images/travel/bannermobile.png"
                        alt="Rovi Travel Banner Mobile"
                        className="block md:hidden absolute inset-0 w-full h-full object-cover rounded-2xl"
                    />

                    {/* Ảnh nền cho desktop */}
                    <img
                        src="/images/travel/banner.png"
                        alt="Rovi Travel Banner"
                        className="hidden md:block absolute inset-0 w-full h-full object-cover scale-105"
                    />

                    {/* Lớp overlay tạo hiệu ứng phủ nền */}
                    <div className="hidden md:block absolute inset-y-0 left-0 w-[70%] xl:w-[60%] bg-gradient-to-r from-black/80 via-black/30 to-transparent z-10 pointer-events-none rounded-2xl" />

                    {/* Thanh breadcrumb điều hướng */}
                    <div
                        className="hidden md:flex absolute top-2 left-2 xl:top-4 xl:left-4 2xl:top-5 2xl:left-5 min-[1920px]:top-8 min-[1920px]:left-8 items-center gap-1 text-white z-20"
                        style={fontStyle}
                    >
                        <Home className="size-3 xl:size-3.5 2xl:size-4 min-[1920px]:size-5" strokeWidth={2} />
                        <ChevronRight className="size-2.5 xl:size-3 2xl:size-3.5 min-[1920px]:size-4 opacity-70" />
                        <span className="text-[10px] xl:text-xs 2xl:text-[13px] min-[1920px]:text-base font-light tracking-wide">
                            Rovi Travel
                        </span>
                    </div>

                    {/* Khối hiển thị QR và CTA */}
                    <div className="absolute z-30 w-[calc(100%-32px)] md:w-auto
                                    top-full left-1/2 -translate-x-1/2 -translate-y-1/2
                                    md:top-1/2 md:left-8 md:translate-x-0
                                    xl:left-32 2xl:left-40 min-[1920px]:left-52">

                        <div className="rounded-xl overflow-hidden shadow-lg md:shadow-none
                                        w-full max-w-full md:max-w-[280px] xl:max-w-[380px] 2xl:max-w-[450px] min-[1920px]:max-w-[550px] 
                                        animate-fade-in-up backdrop-blur-md flex flex-col bg-transparent">

                            {/* Nội dung khung QR */}
                            <div
                                className="flex flex-row items-center justify-center md:justify-start 
                                           p-6 xl:p-6 2xl:p-8 min-[1920px]:p-10 gap-4 xl:gap-5 2xl:gap-8 min-[1920px]:gap-10"
                                style={{
                                    background: 'linear-gradient(94deg, #FFF 0.86%, rgba(255, 255, 255, 0.72) 100%)'
                                }}
                            >
                                {/* Hình ảnh QR */}
                                <div
                                    className="hidden md:block shrink-0 bg-white p-1.5 2xl:p-2 min-[1920px]:p-3 rounded-lg"
                                    style={{ boxShadow: '0 0 39.78px 0 rgba(0, 0, 0, 0.15)' }}
                                >
                                    <img
                                        src="/images/travel/qr-code.png.png"
                                        alt="QR Code"
                                        className="w-20 h-20 xl:w-24 xl:h-24 2xl:w-28 2xl:h-28 min-[1920px]:w-36 min-[1920px]:h-36 object-contain mix-blend-multiply"
                                    />
                                </div>

                                {/* Nội dung tiêu đề và mô tả */}
                                <div className="flex flex-col items-center text-center">
                                    <h2
                                        className="text-[#006633] text-lg md:text-base xl:text-xl 2xl:text-2xl min-[1920px]:text-4xl font-medium leading-tight"
                                        style={fontStyle}
                                    >
                                        Ứng dụng du lịch <br /> tiết kiệm
                                    </h2>

                                    <p
                                        className="hidden md:block text-black/80 text-[10px] xl:text-xs 2xl:text-sm min-[1920px]:text-lg font-semibold mt-1.5 2xl:mt-3"
                                        style={fontStyle}
                                    >
                                        Quét mã QR để tải app
                                    </p>
                                </div>
                            </div>

                            {/* Nút CTA chuyển hướng website */}
                            <div className="bg-[#006633]/90 px-4 py-3 xl:px-6 xl:py-3.5 2xl:px-8 2xl:py-5 min-[1920px]:px-10 min-[1920px]:py-6 flex items-center justify-between group cursor-pointer hover:bg-[#006633] transition-colors">
                                <a
                                    href="https://rovitravel.com"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="flex-1 min-w-0"
                                >
                                    <span
                                        className="text-white text-xs md:text-[10px] xl:text-[10px] 2xl:text-xs min-[1920px]:text-sm font-light tracking-wide truncate pr-2 block text-center md:text-left"
                                        style={fontStyle}
                                    >
                                        Hoặc truy cập website hỗ trợ tư vấn du lịch
                                    </span>
                                </a>
                                <a
                                    href="https://rovitravel.com"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="flex-shrink-0"
                                >
                                    <img
                                        src="/images/travel/arrow.png"
                                        alt="Arrow icon"
                                        className="size-3.5 xl:size-4 2xl:size-5 min-[1920px]:size-6 transition-transform group-hover:translate-x-1 object-contain"
                                    />
                                </a>
                            </div>
                        </div>
                    </div>

                </div>

                {/* Nút gợi ý cuộn trang */}
                <div className="absolute bottom-28 xl:bottom-32 2xl:bottom-40 min-[1920px]:bottom-52 -right-1 xl:right-0 2xl:right-2 min-[1920px]:right-4 -translate-x-1 -rotate-90 origin-bottom-right z-12 hidden xl:block">
                    <div className="flex items-center gap-2 text-black/60">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="1"
                            stroke="currentColor"
                            className="w-5 h-5 2xl:w-6 2xl:h-6 min-[1920px]:w-8 min-[1920px]:h-8"
                            style={{ animation: 'bounce-horizontal 1s infinite' }}
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
                        </svg>
                        <p
                            className="font-normal tracking-[0.12em] text-[10px] 2xl:text-xs min-[1920px]:text-sm uppercase whitespace-nowrap"
                            style={fontStyle}
                        >
                            Scroll Down
                        </p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default BannerSectionFirst
